import { createAsyncThunk } from '@reduxjs/toolkit';

import { isSupportContactPrompt } from '../api/isSupportContactPrompt';
import { HttpClientFactory } from '../httpClient';

export const loadSupportRequest = createAsyncThunk<
  boolean,
  {
    query: string;
    httpClient: HttpClientFactory;
  }
>('loadSupportRequest', async ({ query, httpClient }) => {
  const result = await isSupportContactPrompt(query, httpClient);
  return result;
});
